export const opsMgmtRouteDefs = [
    {
        path: 'help/:identifier',
        component: 'HtmlViewerComponent',
        data: {
          selector: "html-viewer"
        }
    },
    {
      path: 'help-document',
      component: 'HelpDocViewerComponent',
      data: {
        selector: "app-help-doc-viewer"
      }
    },
    {
      path: 'help-document-detail',
      component: 'HelpDocDetailComponent',
      data: {
        selector: "app-help-doc-detail"
      }
    },
]